const { upgradeArray } = require('../utils')

const NOTIFICATIONS_AVAILABLE_TYPES = upgradeArray([ 'email', 'sms', 'web'/* , 'push', 'tgBot' */ ])

module.exports = {
  NOTIFICATIONS_AVAILABLE_TYPES
}
